export default __webpack_public_path__ + "static/media/2697.68d4afd7.png";